// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* :root {
  --background-color: #fff;
  --text-color: #000;
  --primary-color: #5358d5;
  --secondary-color: #7d9aea;
  --highlight-color: #fefefe;
  --modal-background: #fefefe;
}

[data-theme="dark"] {
  --background-color: #3f3f3f;
  --text-color: #f0f0f0;
  --primary-color: #3f3f3f;
  --secondary-color: #3f3f3f;
  --highlight-color: #3f3f3f;
  --modal-background: #3f3f3f;
} */
.prediction-summary {
  background-color: var(--background-color);
  padding: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.prediction-summary:hover {
  background-color: #ffffffbe;
}

.summary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 10px;
}

.profit-loss {
  font-size: 18px;
  font-weight: bold;
}

.profit {
  color: #4caf50;
}

.loss {
  color: #f44336;
}

.details {
  margin-top: 10px;
}

.result-container {
  padding-top: 100px;
  color: var(--text-color);
  background-color: #f0f0f0be;
  min-height: 100vh;
  padding: 20px;
}

.title {
  text-align: center;
  margin-bottom: 20px;
  font-size: 24px;
}

.button-group {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.tab-button {
  background-color: white;
  color: black;
  border: none;
  padding: 10px 20px;
  margin: 0 10px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.tab-button:hover {
  background-color: #555;
}

.tab-button.active {
  background-color: black;
  color: white;
}

.prediction-list {
  list-style: none;
  padding: 0;
}

.no-predictions {
  text-align: center;
  color: #888;
}
`, "",{"version":3,"sources":["webpack://./src/Components/PredictionSummary.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;GAgBG;AACH;EACE,yCAAyC;EACzC,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;EAC3B,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb","sourcesContent":["/* :root {\r\n  --background-color: #fff;\r\n  --text-color: #000;\r\n  --primary-color: #5358d5;\r\n  --secondary-color: #7d9aea;\r\n  --highlight-color: #fefefe;\r\n  --modal-background: #fefefe;\r\n}\r\n\r\n[data-theme=\"dark\"] {\r\n  --background-color: #3f3f3f;\r\n  --text-color: #f0f0f0;\r\n  --primary-color: #3f3f3f;\r\n  --secondary-color: #3f3f3f;\r\n  --highlight-color: #3f3f3f;\r\n  --modal-background: #3f3f3f;\r\n} */\r\n.prediction-summary {\r\n  background-color: var(--background-color);\r\n  padding: 5px;\r\n  margin-bottom: 10px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.prediction-summary:hover {\r\n  background-color: #ffffffbe;\r\n}\r\n\r\n.summary-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.logo {\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 50%;\r\n  margin-right: 10px;\r\n}\r\n\r\n.profit-loss {\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n}\r\n\r\n.profit {\r\n  color: #4caf50;\r\n}\r\n\r\n.loss {\r\n  color: #f44336;\r\n}\r\n\r\n.details {\r\n  margin-top: 10px;\r\n}\r\n\r\n.result-container {\r\n  padding-top: 100px;\r\n  color: var(--text-color);\r\n  background-color: #f0f0f0be;\r\n  min-height: 100vh;\r\n  padding: 20px;\r\n}\r\n\r\n.title {\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n  font-size: 24px;\r\n}\r\n\r\n.button-group {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.tab-button {\r\n  background-color: white;\r\n  color: black;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  margin: 0 10px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.tab-button:hover {\r\n  background-color: #555;\r\n}\r\n\r\n.tab-button.active {\r\n  background-color: black;\r\n  color: white;\r\n}\r\n\r\n.prediction-list {\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n\r\n.no-predictions {\r\n  text-align: center;\r\n  color: #888;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
